import * as t from "io-ts";
import { isObjectKey } from "./object-key.interface.mjs";
import { isObjectTimestamps } from "./object-timestamps.interface.mjs";
// #endregion Interfaces (1)
// #region Functions (1)
export function isObjectBase(value) {
  const tag = IObjectBaseType.decode(value)._tag;
  tag === "Right";
  return isObjectKey(value) && isObjectTimestamps(value);
}
// #endregion Functions (1)
// #region Variables (1)
export const IObjectBaseType = t.type({});
// #endregion Variables (1)